import React, { createContext, useState, useCallback, useContext } from 'react';
import Toast from '../components/Toast';

export const ToastContext = createContext({
  toast: function () {},
});

export function useToast() {
  const ctx = useContext(ToastContext);
  if (!ctx) throw new Error('useToast must be used within ToastProvider');
  return ctx;
}

const DEFAULT_DURATION = 4000;

function ToastProvider({ children }) {
  const [toasts, setToasts] = useState([]);

  const toast = useCallback(function (message, type = 'info', duration = DEFAULT_DURATION) {
    const id = Date.now() + Math.random();
    setToasts(function (prev) {
      return [...prev, { id, message, type }];
    });
    setTimeout(function () {
      setToasts(function (prev) {
        return prev.filter(function (t) { return t.id !== id; });
      });
    }, duration);
  }, []);

  const removeToast = useCallback(function (id) {
    setToasts(function (prev) {
      return prev.filter(function (t) { return t.id !== id; });
    });
  }, []);

  return (
    <ToastContext.Provider value={{ toast }}>
      {children}
      <Toast toasts={toasts} removeToast={removeToast} />
    </ToastContext.Provider>
  );
}

export default ToastProvider;
